"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f100 = void 0;
exports.f100 = {
    "da": [
        "Latn",
        "Brai"
    ],
    "daa": [
        "Latn"
    ],
    "dac": [
        "Latn"
    ],
    "dad": [
        "Latn"
    ],
    "dae": [
        "Latn"
    ],
    "dag": [
        "Latn",
        "Arab"
    ],
    "dah": [
        "Latn"
    ],
    "dai": [
        "Latn"
    ],
    "daj": [
        "Latn"
    ],
    "dak": [
        "Latn"
    ],
    "dal": [
        "Latn"
    ],
    "dam": [
        "Latn"
    ],
    "dao": [
        "Latn"
    ],
    "daq": [
        "Deva"
    ],
    "dar": [
        "Cyrl"
    ],
    "das": [
        "Latn"
    ],
    "dau": [
        "Latn"
    ],
    "dav": [
        "Latn"
    ],
    "daw": [
        "Latn"
    ],
    "dax": [
        "Latn"
    ],
    "daz": [
        "Latn"
    ],
    "dba": [
        "Latn"
    ],
    "dbb": [
        "Latn"
    ],
    "dbd": [
        "Latn"
    ],
    "dbe": [
        "Latn"
    ],
    "dbf": [
        "Latn"
    ],
    "dbg": [
        "Latn"
    ],
    "dbi": [
        "Latn"
    ],
    "dbj": [
        "Latn",
        "Arab"
    ],
    "dbl": [
        "Latn"
    ],
    "dbm": [
        "Latn"
    ],
    "dbn": [
        "Latn"
    ],
    "dbo": [
        "Latn"
    ],
    "dbp": [
        "Latn"
    ],
    "dbq": [
        "Latn"
    ],
    "dbr": [
        "Zyyy"
    ],
    "dbt": [
        "Latn"
    ],
    "dbu": [
        "Latn"
    ],
    "dbv": [
        "Latn"
    ],
    "dbw": [
        "Latn"
    ],
    "dby": [
        "Latn"
    ],
    "dcc": [
        "Arab",
        "Deva"
    ],
    "dcr": [
        "Latn"
    ],
    "dda": [
        "Latn"
    ],
    "ddd": [
        "Latn"
    ],
    "dde": [
        "Latn"
    ],
    "ddg": [
        "Latn"
    ],
    "ddi": [
        "Latn"
    ],
    "ddj": [
        "Latn"
    ],
    "ddn": [
        "Latn"
    ],
    "ddo": [
        "Cyrl"
    ],
    "ddr": [
        "Latn"
    ],
    "dds": [
        "Latn"
    ],
    "ddw": [
        "Latn"
    ],
    "de": [
        "Latn",
        "Brai",
        "Dupl",
        "Latf",
        "Runr"
    ],
    "dec": [
        "Latn"
    ],
    "ded": [
        "Latn"
    ],
    "dee": [
        "Latn"
    ],
    "def": [
        "Arab"
    ],
    "deg": [
        "Latn"
    ],
    "deh": [
        "Arab"
    ],
    "dei": [
        "Latn"
    ],
    "dek": [
        "Latn"
    ],
    "del": [
        "Latn"
    ],
    "dem": [
        "Latn"
    ],
    "den": [
        "Latn",
        "Cans"
    ],
    "dep": [
        "Zyyy"
    ],
    "deq": [
        "Latn"
    ],
    "der": [
        "Beng",
        "Latn"
    ],
    "des": [
        "Latn"
    ],
    "dev": [
        "Latn"
    ],
    "dez": [
        "Latn"
    ],
    "dga": [
        "Latn"
    ],
    "dgb": [
        "Latn"
    ],
    "dgc": [
        "Latn"
    ],
    "dgd": [
        "Latn"
    ],
    "dge": [
        "Latn"
    ],
    "dgg": [
        "Latn"
    ],
    "dgh": [
        "Latn"
    ],
    "dgi": [
        "Latn"
    ],
    "dgk": [
        "Latn"
    ],
    "dgl": [
        "Arab",
        "Copt",
        "Latn"
    ],
    "dgn": [
        "Latn"
    ],
    "dgr": [
        "Latn"
    ],
    "dgs": [
        "Latn"
    ],
    "dgt": [
        "Latn"
    ],
    "dgu": [
        "Zyyy"
    ],
    "dgw": [
        "Latn"
    ],
    "dgx": [
        "Latn"
    ],
    "dgz": [
        "Latn"
    ],
    "dhg": [
        "Latn"
    ],
    "dhi": [
        "Deva"
    ],
    "dhl": [
        "Latn"
    ],
    "dhm": [
        "Latn"
    ],
    "dhn": [
        "Gujr"
    ],
    "dho": [
        "Deva"
    ],
    "dhr": [
        "Latn"
    ],
    "dhs": [
        "Latn"
    ],
    "dhu": [
        "Latn"
    ],
    "dhv": [
        "Latn"
    ],
    "dhw": [
        "Deva"
    ],
    "dhx": [
        "Latn"
    ],
    "dia": [
        "Latn"
    ],
    "dib": [
        "Latn"
    ],
    "dic": [
        "Latn"
    ],
    "did": [
        "Latn"
    ],
    "dif": [
        "Latn"
    ],
    "dig": [
        "Latn"
    ],
    "dih": [
        "Latn"
    ],
    "dii": [
        "Latn"
    ],
    "dij": [
        "Latn"
    ],
    "dil": [
        "Latn"
    ],
    "dim": [
        "Zyyy"
    ],
    "din": [
        "Latn",
        "Arab"
    ],
    "dio": [
        "Latn"
    ],
    "dip": [
        "Latn"
    ],
    "dir": [
        "Latn"
    ],
    "dis": [
        "Beng",
        "Latn"
    ],
    "diu": [
        "Latn"
    ],
    "diw": [
        "Latn"
    ],
    "dix": [
        "Latn"
    ],
    "diy": [
        "Latn"
    ],
    "diz": [
        "Latn"
    ],
    "dja": [
        "Latn"
    ],
    "djb": [
        "Latn"
    ],
    "djc": [
        "Latn"
    ],
    "djd": [
        "Latn"
    ],
    "dje": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "djf": [
        "Latn"
    ],
    "dji": [
        "Latn"
    ],
    "djj": [
        "Latn"
    ],
    "djk": [
        "Latn",
        "Afak"
    ],
    "djm": [
        "Latn"
    ],
    "djn": [
        "Latn"
    ],
    "djo": [
        "Latn"
    ],
    "djr": [
        "Latn"
    ],
    "dju": [
        "Latn"
    ],
    "djw": [
        "Latn"
    ],
    "dka": [
        "Tibt"
    ],
    "dkg": [
        "Latn"
    ],
    "dkk": [
        "Latn"
    ],
    "dkr": [
        "Latn"
    ],
    "dks": [
        "Latn"
    ],
    "dkx": [
        "Latn"
    ],
    "dlg": [
        "Cyrl"
    ],
    "dlk": [
        "Zyyy"
    ],
    "dlm": [
        "Latn"
    ],
    "dln": [
        "Latn"
    ],
    "dma": [
        "Latn"
    ],
    "dmb": [
        "Latn"
    ],
    "dmc": [
        "Latn"
    ],
    "dmd": [
        "Latn"
    ],
    "dme": [
        "Latn"
    ],
    "dmf": [
        "Medf"
    ],
    "dmg": [
        "Latn"
    ],
    "dmk": [
        "Arab"
    ],
    "dml": [
        "Arab"
    ],
    "dmm": [
        "Latn"
    ],
    "dmo": [
        "Latn"
    ],
    "dmr": [
        "Latn"
    ],
    "dms": [
        "Latn"
    ],
    "dmu": [
        "Latn"
    ],
    "dmv": [
        "Latn"
    ],
    "dmw": [
        "Latn"
    ],
    "dmx": [
        "Latn"
    ],
    "dmy": [
        "Latn"
    ],
    "dna": [
        "Latn"
    ],
    "dnd": [
        "Latn"
    ],
    "dne": [
        "Latn"
    ],
    "dng": [
        "Cyrl"
    ],
    "dni": [
        "Latn"
    ],
    "dnj": [
        "Latn"
    ],
    "dnk": [
        "Latn"
    ],
    "dnn": [
        "Latn"
    ],
    "dno": [
        "Latn"
    ],
    "dnr": [
        "Latn"
    ],
    "dnt": [
        "Latn"
    ],
    "dnu": [
        "Mymr"
    ],
    "dnv": [
        "Zyyy"
    ],
    "dnw": [
        "Latn"
    ],
    "dny": [
        "Latn"
    ],
    "doa": [
        "Latn"
    ],
    "dob": [
        "Latn"
    ],
    "doc": [
        "Latn"
    ],
    "doe": [
        "Latn"
    ],
    "dof": [
        "Latn"
    ],
    "doh": [
        "Latn"
    ],
    "doi": [
        "Arab",
        "Deva",
        "Takr"
    ],
    "dok": [
        "Latn"
    ],
    "dol": [
        "Latn"
    ],
    "don": [
        "Latn"
    ],
    "doo": [
        "Latn"
    ],
    "dop": [
        "Latn"
    ],
    "doq": [
        "Zxxx"
    ],
    "dor": [
        "Latn"
    ],
    "dos": [
        "Latn"
    ],
    "dot": [
        "Latn"
    ],
    "dov": [
        "Latn"
    ],
    "dow": [
        "Latn"
    ],
    "dox": [
        "Ethi"
    ],
    "doy": [
        "Latn"
    ],
    "doz": [
        "Zyyy"
    ],
    "dpp": [
        "Latn"
    ],
    "drb": [
        "Zyyy"
    ],
    "drc": [
        "Latn"
    ],
    "drd": [
        "Zyyy"
    ],
    "dre": [
        "Tibt"
    ],
    "drg": [
        "Latn"
    ],
    "dri": [
        "Latn"
    ],
    "drl": [
        "Latn"
    ],
    "drn": [
        "Latn"
    ],
    "dro": [
        "Latn"
    ],
    "drq": [
        "Zyyy"
    ],
    "drs": [
        "Ethi"
    ],
    "drt": [
        "Latn"
    ],
    "dru": [
        "Latn"
    ],
    "dry": [
        "Deva"
    ],
    "dsb": [
        "Latn"
    ],
    "dse": [
        "Zxxx"
    ],
    "dsh": [
        "Latn"
    ],
    "dsi": [
        "Latn"
    ],
    "dsl": [
        "Zxxx"
    ],
    "dsn": [
        "Latn"
    ],
    "dso": [
        "Orya"
    ],
    "dsq": [
        "Arab",
        "Latn"
    ],
    "dta": [
        "Latn",
        "Cyrl",
        "Hans",
        "Mong"
    ],
    "dtb": [
        "Latn"
    ],
    "dtd": [
        "Latn"
    ],
    "dth": [
        "Latn"
    ],
    "dti": [
        "Latn"
    ],
    "dtk": [
        "Latn"
    ],
    "dtm": [
        "Latn"
    ],
    "dtn": [
        "Zyyy"
    ],
    "dto": [
        "Latn"
    ],
    "dtp": [
        "Latn"
    ],
    "dtr": [
        "Latn"
    ],
    "dts": [
        "Latn"
    ],
    "dtt": [
        "Latn"
    ],
    "dtu": [
        "Latn"
    ],
    "dty": [
        "Deva"
    ],
    "dua": [
        "Latn"
    ],
    "dub": [
        "Gujr"
    ],
    "duc": [
        "Latn"
    ],
    "due": [
        "Latn"
    ],
    "duf": [
        "Latn"
    ],
    "dug": [
        "Latn"
    ],
    "duh": [
        "Deva",
        "Gujr"
    ],
    "dui": [
        "Latn"
    ],
    "duk": [
        "Latn"
    ],
    "dul": [
        "Latn"
    ],
    "dum": [
        "Latn"
    ],
    "dun": [
        "Latn"
    ],
    "duo": [
        "Latn"
    ],
    "dup": [
        "Latn"
    ],
    "duq": [
        "Latn"
    ],
    "dur": [
        "Latn"
    ],
    "dus": [
        "Deva"
    ],
    "duu": [
        "Latn"
    ],
    "duv": [
        "Latn"
    ],
    "duw": [
        "Latn"
    ],
    "dux": [
        "Latn"
    ],
    "duy": [
        "Latn"
    ],
    "duz": [
        "Latn"
    ],
    "dv": [
        "Thaa",
        "Diak"
    ],
    "dva": [
        "Latn"
    ],
    "dwa": [
        "Latn"
    ],
    "dwk": [
        "Orya"
    ],
    "dwr": [
        "Latn",
        "Ethi"
    ],
    "dws": [
        "Latn"
    ],
    "dwu": [
        "Latn"
    ],
    "dww": [
        "Latn"
    ],
    "dwy": [
        "Latn"
    ],
    "dwz": [
        "Deva"
    ],
    "dya": [
        "Latn"
    ],
    "dyb": [
        "Latn"
    ],
    "dyd": [
        "Latn"
    ],
    "dyg": [
        "Latn"
    ],
    "dyi": [
        "Latn"
    ],
    "dym": [
        "Latn"
    ],
    "dyn": [
        "Latn"
    ],
    "dyo": [
        "Latn",
        "Arab"
    ],
    "dyu": [
        "Latn",
        "Arab",
        "Nkoo"
    ],
    "dyy": [
        "Latn"
    ],
    "dz": [
        "Tibt"
    ],
    "dza": [
        "Latn"
    ],
    "dze": [
        "Latn"
    ],
    "dzg": [
        "Latn"
    ],
    "dzl": [
        "Tibt"
    ],
    "dzn": [
        "Latn"
    ]
};
